/* eslint-disable no-inner-declarations */
import Swiper, { Autoplay, Navigation, Scrollbar } from 'swiper';
import { swiperObserver } from '../utils/swiper.utils.js';

let ourTeamSwiperWr = document.querySelectorAll('.our-team-swiper-wr');

ourTeamSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let parentEl = el.parentElement;
    let nextEl = parentEl.querySelector('.swiper-button-next');
    let prevEl = parentEl.querySelector('.swiper-button-prev');
    let scrollbarEl = parentEl.querySelector('.our-team-sec__scrollbar');
    const items = document.querySelectorAll('.our-team-sec__item');


    console.log('SRC')
    if(items.length) {
      items[0].classList.add('active');
      setTimeout(() => {
        swiper.autoplay.stop();
        swiper.update()
      }, 450);
    }

    items.forEach((item, i) => {
      item.addEventListener('click', (e) => changeActiveItem(e, i));
    });

    const changeActiveItem = (e, i) => {
      const item = items[i];

      console.log(item)

      // if (item.classList.contains('active') && (e.target.classList.contains('our-team-sec__item-button') || e.target.tagName === 'I')) {
      //   item.classList.remove('active');

      //   const hasActive = [...items].some(it => it.classList.contains('active'));
      //   if (!hasActive) swiper.autoplay.start();

      //   return;
      // }

      if(item.classList.contains('active')) {
        return
      }

      // if(item.classList.contains('active') && !item.classList.contains('swiper-slide-active')) {
      //   item.classList.remove('active');
      // }

      items.forEach(it => it.classList.remove('active'));
      // swiper.update(); 

      setTimeout(() => {
        item.classList.add('active');
        swiper.autoplay.stop();
        swiper.update(); 
        swiper.slideTo(i, 350); 
      }, 500);
    }


    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Scrollbar],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 14,
      slidesPerView: 1,
      threshold: 10,
      // slideToClickedSlide: true,
      // freeMode: true,
      /*loop: true,*/
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      scrollbar: {
        el: scrollbarEl,
        draggable: true,
      },
      breakpoints: {
        500: {
          slidesPerView: 1,
        },
        641: {
          slidesPerView: 1,
        },
        769: {
          spaceBetween: 20,
          slidesPerView: 1,
        },
      },
      autoplay: {
        delay: 800000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      on: {
        slideChange: (swiper) => {
          changeActiveItem(items[swiper.activeIndex], swiper.activeIndex)
        }
      }
    });

    swiperObserver(swiper);
  }
});


